
import IDateRange from "@/../types/custom";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { Component, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import CommissionAttendantsGraphic from "@/components/CommissionAttendantsGraphic.vue";
import ReportService from "../services/reportService";
import DateRangePicker from "vue2-daterange-picker";
import SaasService from "@/services/SaasService";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/material.css'
import AppService from "@/services/integration/AppService";

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    CommissionAttendantsGraphic,
    vSelect,
    VueSlider
  },
})
export default class CostReport extends Vue {
  private saasServiceInstance = new SaasService();

  private activeFilter: boolean = false;
  private loadingMetric: boolean = false;
  private loadingConvs: boolean = false;

  private getConvsResponse: any;
  private convObjsArr: any = [];
  private convFields = [
    {key: 'details', label: 'Detalhes', sortable: true},
    {key: 'plugin', label: 'Plugin', sortable: true},
    {key: 'channel', label: 'Canal', sortable: true},
    {key: 'action', label: 'Ação', sortable: true},
    {key: 'status', label: 'Status', sortable: true},
    {key: 'sentiment', label: 'Sentimento', sortable: true},
    {key: 'csat', label: 'CSAT', sortable: true},
    {key: 'chat_id', label: ''},
  ]

  private dateRange: IDateRange = {
    startDate: "",
    endDate: "",
  };

  private csatRange: number[] = [0, 100];

  // Set persistent value label (tooltip) on CSAT range
  private dotOptions: any = [
    { tooltip: 'always' },
    { tooltip: 'always' }
  ]

  // TODO: change from hardcoded to request
  private filterPlugins: string[] = [
    'Abandono de carrinho',
    'Exit popup',
    'Base 23/09/21'
  ]
  private filterChannels: string[] = [
    'Whatsapp',
    'Ligação'
  ]
  private filterActions: string[] = [
    'Venda',
    'Recompra'
  ]

  private selectedPlugins: string[] = [];
  private selectedChannels: string[] = [];
  private selectedActions: string[] = [];
  private selectedStatus: string[] = [];
  private selectedSentiments: string[] = [];

  private limitDateSale  = this.$moment().format('YYYY-MM-DD HH:mm:ss');

  private async sendDateFilter() {
    this.loadingMetric = !this.loadingMetric;
    this.$bvModal.hide("date-modal");
  }

  private async sendFilter() {
    this.loadingMetric = !this.loadingMetric; // TODO:
    this.activeFilter = true;
    this.getConvs();
    this.$bvModal.hide('filter-modal');
    this.$bvModal.hide("date-modal");

  }

    private clearFilterDate() {
    this.dateRange.startDate = this.$moment().format("YYYY/MM/DD");
    this.dateRange.endDate = this.$moment().format("YYYY/MM/DD");
    this.$bvModal.hide("date-modal");
  }


  private clearFilter() {
    // TODO: send get request without filters
    this.selectedPlugins = []
    this.selectedChannels = []
    this.selectedActions = []
    this.selectedStatus = []
    this.selectedSentiments = []
    this.csatRange = [0, 100]
    this.activeFilter = false;
    this.$bvModal.hide('filter-modal')
  }

  private filterDateFormat() {
    let result = "Filtro por data";
    if (this.dateRange.startDate) {
      result = String(
        (this.$moment(this.dateRange.startDate) as any).format("DD/MM/YYYY")
      );
      this.dateRange.endDate = this.dateRange.endDate ? this.dateRange.endDate : this.dateRange.startDate;
      result +=
        " - " +
        String((this.$moment(this.dateRange.endDate) as any).format("DD/MM/YYYY"));
    }
    return result;
  }

  alert(str: string) {
    alert(str)
  }

  private async getConvs() {
    this.loadingConvs = true;
    this.getConvsResponse = {};
    this.convObjsArr = [];

    const appService = new AppService();
    this.convObjsArr = await appService.getMessageDetails(
        this.$moment(this.dateRange.startDate).format("YYYY/MM/DD"),
        this.$moment(this.dateRange.endDate).format("YYYY/MM/DD")
    );

    this.loadingConvs = false;
  }

  private getLastWeekRange() {
    this.dateRange.startDate = this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
    this.dateRange.endDate = this.$moment().subtract(1, 'days').format('YYYY-MM-DD')
  }

  // TODO: open complete chat modal when backend is ready
  private openChat(chatId) {
    console.log(chatId)
  }

  private async created() {
    this.getLastWeekRange()
    this.getConvs()
  }
}
